import { useQuery } from "@tanstack/react-query";
import { getQuestionOptions } from "../../services/questionOptions";


const useGetQuestionOptions = () => {
    return useQuery({
        queryKey: ["question-options"],
        queryFn: getQuestionOptions,
        staleTime: Infinity,
    });
}

export default useGetQuestionOptions;